<!-- 考试详情 -->
<template>
  <div class="examInfo">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input
          v-model.trim="query.query"
          placeholder="请输入姓名"
          style="width: 200px"
          @keyup.enter.native="frechLoad"
          @clear="
            query.query = '';
            frechLoad();
          "
          clearable
          suffix-icon="el-icon-search"
        ></el-input>
        <Debounce>
          <el-button style="margin:0px 10px;" size="small" @click="frechLoad"
            >查询</el-button
          >
        </Debounce>
        <el-select
          v-model="query.provinceId"
          filterable
          @change="frechLoad"
          placeholder="请选择"
        >
          <el-option label="全部省份" value=""></el-option>
          <el-option
            v-for="item in proList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="query.examSiteId"
          @change="frechLoad"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部市代" value=""></el-option>
          <el-option
            v-for="item in examSitList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="query.registerId"
          @change="frechLoad"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部考点" value=""></el-option>
          <el-option
            v-for="item in rationSiteList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="query.subjectLevel"
          @change="frechLoad"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部报考等级" value=""></el-option>
          <el-option
            v-for="item in lvList"
            :key="item.id"
            :label="item.lv"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-col>
      <!--      <Debounce>-->
      <!--        <el-button type="primary" style="margin-right:10px;" size="small" v-if="$roleFilter('process:whether')" @click="setQualified">生成通过结果</el-button>-->
      <!--      </Debounce>-->
      <el-button
        type="primary"
        v-if="
          (Array.isArray($store.state.user.user.roleInfo) &&
            $store.state.user.user.roleInfo.length > 0 &&
            $store.state.user.user.roleInfo[0].roleName == '学校管理员') ||
            $store.state.user.user.userName == 'admin'
        "
        size="small"
        @click="allocationJug"
        >分配评委</el-button
      >
      <Debounce>
        <el-button
          type="primary"
   
          size="small"
          :loading="exportTicketLoading"
          @click="importFile"
          >导出准考证</el-button
        >
      </Debounce>
      <!--      <el-button type="primary" size="small" v-if="$roleFilter('process:ratio')" @click="operatInfo(1)">通过率设置</el-button>-->
      <Mydialog v-bind="modelOption" @modalVisiabal="changeModel">
        <template #content>
          <el-form
            :model="ruleForm"
            :rules="rules"
            label-width="100px"
            ref="ruleForm"
          >
            <el-form-item label="选择评委：" prop="judge">
              <el-select
                v-model="ruleForm.judge"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in judgeList"
                  :label="item.label"
                  :key="item.value"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </template>
        <template #footer>
          <el-button @click="calc('ruleForm')">取消</el-button>
          <el-button type="primary" @click="handleOk('ruleForm')"
            >确定</el-button
          >
        </template>
      </Mydialog>
    </el-row>
    <el-table
      :data="tableList"
      tooltip-effect="dark"
      border
      ref="elTable"
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
      @filter-change="filterChange"
      :header-cell-style="$store.getters.getTableHeadStyle"
      v-loading="tableIsLoad"
      element-loading-text="加载中"
      :height="$store.getters.getTableHeight - 50"
    >
      <el-table-column type="selection" :selectable="selectCheck">
      </el-table-column>
      <el-table-column
        type="index"
        width="50"
        label="序号"
        align="center"
        :index="Nindex"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
        sortable="custom"
      ></el-table-column>
      <el-table-column width="80" label="性别" align="center">
        <template slot-scope="scope">
          {{ scope.row.sex === 1 ? "男" : "女" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="age"
        label="年龄"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="idNumber"
        label="证件号码"
        width="180px"
        align="center"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        prop="provinceName"
        label="省份"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="examSiteName"
        label="市级代理"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="registerSiteName"
        show-overflow-tooltip
        label="考点"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="subjectLevel_dictText"
        label="报考等级"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column label="考试视频" key="videoPath" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="scope.row.videoPath"
            size="small"
            @click="operatInfo(3, scope.row)"
            >考试视频
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="准考证" key="examId" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="operatInfo(2, scope.row)"
            >查看准考证</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        label="发证日期"
        show-overflow-tooltip
        key="fzTime"
        prop="fzTime"
        align="center"
        v-if="
          (Array.isArray($store.state.user.user.roleInfo) &&
            $store.state.user.user.roleInfo.length > 0 &&
            $store.state.user.user.roleInfo[0].roleName == '学校管理员') ||
            $store.state.user.user.userName == 'admin'
        "
      >
      </el-table-column>
      <el-table-column
        label="评委"
        show-overflow-tooltip
        key="judgeName"
        prop="judgeName"
        align="center"
        v-if="
          (Array.isArray($store.state.user.user.roleInfo) &&
            $store.state.user.user.roleInfo.length > 0 &&
            $store.state.user.user.roleInfo[0].roleName == '学校管理员') ||
            $store.state.user.user.userName == 'admin'
        "
      >
      </el-table-column>
      <el-table-column
        v-if="
          (Array.isArray($store.state.user.user.roleInfo) &&
            $store.state.user.user.roleInfo.length > 0 &&
            $store.state.user.user.roleInfo[0].roleName == '学校管理员') ||
            $store.state.user.user.userName == 'admin'
        "
        key="score"
        prop="score"
        label="成绩分数"
        align="center"
        sortable="custom"
        :min-width="110"
      >
        <template slot-scope="scope">
          
          <span v-if="queryState == 1">{{
            scope.row.score == -1 ? "" : scope.row.score
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
      
        key="lv"
        label="成绩等级"
        align="center"
        :min-width="110"
        column-key="whetherPass"
        :filter-multiple="false"
        filter-placement="bottom-end"
        :filters="[
          { text: '合格', value: 1 },
          { text: '不合格', value: 2 },
          { text: '优秀', value: 3 },
          { text: '空', value: 0 },
        ]"
      >
        <template slot-scope="{ row }">
          <span
          
            :style="{
              color: getTextAndColor(row.whetherPass).color,
            }"
            >{{ getTextAndColor(row.whetherPass).text }}</span
          >
          <!-- <span v-else>-</span> -->
        </template>
      </el-table-column>
      <el-table-column
        v-if="
          queryState == 1 &&
            ((Array.isArray($store.state.user.user.roleInfo) &&
              $store.state.user.user.roleInfo.length > 0 &&
              $store.state.user.user.roleInfo[0].roleName == '学校管理员') ||
              $store.state.user.user.userName == 'admin')
        "
        key="fzTime1"
        label="考级证书"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="queryState == 1">
            <!-- <span v-if="(scope.row.fzTime || scope.row.fzTime) && scope.row.score == -1"></span>
            <span style="color:#8AC404"
              v-else-if="scope.row.fzTime == null || scope.row.fzTime == '' || scope.row.score == -1">未生成</span> -->
            <span style="color:#8AC404" v-if="scope.row.sinFile == null || scope.row.sinFile == ''"
              >未生成</span
            >
            <span style="color:#409EFF" v-else>已生成</span>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :total="query.total"
      :page.sync="query.pageNum"
      :limit.sync="query.pageSize"
      :page-sizes="pageSizes"
      class="pagination-content"
      @pagination="tableLoad"
    />
    <el-dialog
      custom-class="dailogComponents"
      :title="visibleType == 1 ? '通过率设置' : '查看视频'"
      :visible.sync="visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      v-if="visible"
      width="800px"
    >
      <div v-show="visibleType == 1" class="dialogBox">
        <el-table
          :data="passRateList"
          tooltip-effect="dark"
          border
          ref="elTable"
          style="width: 100%;"
          :header-cell-style="$store.getters.getTableHeadStyle"
          element-loading-text="加载中"
          :height="500"
        >
          <el-table-column
            prop="provinceName"
            label="省份"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="examSiteName"
            label="考点"
            align="center"
          ></el-table-column>
          <el-table-column label="报考等级" align="center">
            <template slot-scope="scope">
              {{ scope.row.subjectLevel | getLvTextByLv }}
            </template>
          </el-table-column>
          <el-table-column
            prop="registerNum"
            label="考试总人数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="passNum"
            label=">=60分人数"
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="score"
            label="平均分"
            align="center"
          ></el-table-column>
          <el-table-column label="通过率(%)" align="center" width="200">
            <template slot-scope="scope">
              <div>
                <el-input-number
                  class="tableNumInput"
                  style="width:100%"
                  @change="detection($event, scope.row)"
                  v-model="scope.row.ratio"
                  :min="0"
                  :max="100"
                ></el-input-number>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-button size="medium" @click="visible = false">取消</el-button>
          <el-button size="medium" type="primary" @click="submit"
            >确认</el-button
          >
        </el-row>
      </div>
      <div
        v-show="visibleType == 3"
        class="dialogBox"
        style="text-align: center"
      >
        <el-pagination
          background
          layout="prev, pager, next"
          :page-count="currentVideoList.length"
          :current-page="currentVideoIndex"
          @current-change="handleCurrentChange"
          style="padding-bottom: 10px"
        />
        <el-row type="flex" justify="space-around">
          <video-player
            :class="getVideoClass"
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            @ended="onPlayerEnded($event)"
            :playsinline="true"
            :options="playerOptions"
            @ready="playerIsReady"
          ></video-player>
        </el-row>
        <p class="wxts">
          温馨提示：若不能正常播放，请用360极速浏览器查看视频并关闭硬件加速。
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { exportFile } from "@/uitls/globalFun.js";
import Mydialog from "../../../../components/global/myDialog.vue";
import * as videojs from "video.js";
import "videojs-flash";
import "videojs-hotkeys";

export default {
  components: {
    Mydialog,
  },
  beforeCreate() {
    if (!this.$route.query.id || !this.$route.query.name) {
      this.$router.go(-1);
      this.$message({
        type: "warning",
        message: "id已过期,请重新查看!",
        duration: 1000,
      });
      return;
    }
  },
  async created() {
    let navList = this.$store.state.websetting.navBreadList;
    navList[2].title = this.$route.query.name + "考试详情";
    this.$store.commit("setNav", navList);
    this.query.examId = this.$route.query.id;
    this.query.notSubmitNum = this.$route.query.notSubmitNum;
    this.queryState = this.$route.query.queryState;
    let { userName, roleIdList } = this.$store.getters.getUser;
    // 学校管理员和admin不受影响
    if (userName == "admin") {
      this.queryState = 1;
    }
    if (
      roleIdList !== null &&
      roleIdList.findIndex((item) => item == 1) !== -1
    ) {
      this.queryState = 1;
    }
    await this.tableLoad();
    this.$nextTick(() => {
      this.$refs.elTable.doLayout();
    });
    this.getSelectList();
    this.getJudge();
  },
  watch: {
    tableList() {
      this.$nextTick(() => {
        this.$refs.elTable.doLayout();
      });
    },
  },
  data() {
    return {
      ruleForm: {
        judge: "",
      },
      rules: {
        judge: [{ required: true, message: "请选择评委！", trigger: "blur" }],
      },
      judgeList: [], //评委下拉菜单
      tableList: [],
      passRateList: [],
      proList: [], //省份考点下拉菜单
      lvList: [
        { id: 1, lv: "一级" },
        { id: 2, lv: "二级" },
        { id: 3, lv: "三级" },
        { id: 4, lv: "四级" },
        { id: 5, lv: "五级" },
        { id: 6, lv: "六级" },
        { id: 7, lv: "七级" },
        { id: 8, lv: "八级" },
        { id: 9, lv: "九级" },
        { id: 10, lv: "十级" },
        { id: 11, lv: "初级" },
        { id: 12, lv: "中级" },
        { id: 13, lv: "高级" },
      ], //报考等级下拉
      examSitList: [], //市代下拉菜单
      rationSiteList: [], // 考点下拉框
      tableIsLoad: true,
      visible: false,
      exportTicketLoading: false, //导出准考证
      visibleType: 0, //删除
      pageSizes: [15, 25, 50, 100, 500, 1000],
      query: {
        query: "",
        registerId: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        examId: "", //考试ID
        examSiteId: "", //考点ID
        provinceId: "", //省份Id
        subjectLevel: "", //报考等级ID
        notSubmitNum: "", //未上传人数
        orderByField: null, //过滤字段
        orderByMethod: null, //过滤方法
        whetherPass: null, //是否通过
        orderByChineseMethod: null, //姓名排序
        orderByChineseField: null, //姓名排序
      },
      playerOptions: {
        muted: false,
        language: "zh-CN",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            src: "",
            type: "",
          },
        ],
        notSupportedMessage: "此视频暂无法播放，请联系管理员！",
        poster: "../../../assets/img/video.png", //你的封面地址
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      videoRotate: 0,
      queryState: 1,
      currentVideoList: null,
      currentVideoIndex: null,
      modelOption: {
        // 对话框显示状态
        modalVisiabal: false,
        // 标题内容
        title: "",
        // 样式名
        className: "",
        width: "350px",
        // 对话框top值
        top: "30vh",
        // 是否可以点击阴影隐藏对话框
        closeOnClickModal: false,
      },
      multipleSelection: [],
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    getVideoClass() {
      return ["", "videos-rotate1", "videos-rotate2", "videos-rotate3"][
        this.videoRotate
      ];
    },
  },
  methods: {
    frechLoad() {
      this.query.pageNum = 1;
      this.tableLoad();
    },
    Nindex(index) {
      // 当前页数 - 1 * 每页数据条数 + 1
      const page = this.query.pageNum; // 当前页码
      const pagesize = this.query.pageSize; // 每页条数
      return index + 1 + (page - 1) * pagesize;
    },
    getTextAndColor(val) {
      let text = ["", "合格", "不合格", "优秀"][val],
        color = ["", "#66CC66", "#f56c6c", "#409eff"][val];
      return {
        text,
        color,
      };
    },
    //检测单行是否验证通过
    detection(val, row) {
      this.$axios
        .post("/process/notice", {
          newRatio: val,
          oldRatio: row.oldVal,
          sumNum: row.registerNum,
        })
        .then((res) => {
          let data = res.data.data;
          if (data > 0) {
            this.$message.warning(
              `设置改通过率会有${data}个小于60分考生的考试结果为通过，是否确认？`
            );
          }
        });
    },
    //列表排序改变事件
    sortChange(column) {
      console.log(column);
      if (column != null && column.order != null) {
        this.query.orderByMethod =
          column.order === "ascending" ? "asc" : "desc";
        this.query.orderByField =
          column.prop === "idNumber" ? "id_number" : column.prop;
        //排序字段为名字
        if (column.prop === "name") {
          this.query.orderByMethod = null;
          this.query.orderByField = null;
          this.query.orderByChineseMethod =
            column.order === "ascending"
              ? "asc"
              : column.order === "ascending"
              ? "descending"
              : "desc";
          this.query.orderByChineseField = column.prop;
        } else {
          this.query.orderByChineseMethod = null;
          this.query.orderByChineseField = null;
        }
      } else {
        this.query.orderByMethod = null;
        this.query.orderByField = null;
      }

      this.tableLoad();
    },
    //过滤事件
    filterChange(filters) {
      if (filters != null) {
        this.query.whetherPass =
          filters.whetherPass.length > 0 ? filters.whetherPass[0] : null;
      }
      this.tableLoad();
    },
    // 初始化表格
    async tableLoad() {
      await this.$axios.post("/process/detail", this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    // 合格率回显
    getPassRate() {
      let notSubmitNum = this.query.notSubmitNum;
      //如果有人未提交视频则出弹框
      if (notSubmitNum != 0) {
        this.$dailog({
          title: "提示",
          context:
            "还有" +
            notSubmitNum +
            "个考生未上传视频，最终成绩将做0分处理，是否确定?",
          callbackFun: () => {
            this.$axios
              .get("/process/ratio/" + this.query.examId)
              .then((res) => {
                let data = res.data.data;
                if (data) {
                  this.passRateList = data.map((item) => {
                    item.oldVal = item.ratio;
                    return item;
                  });
                  this.visible = true;
                } else {
                  this.passRateList = [];
                  this.visible = false;
                }
              });
          },
        });
      } else {
        this.$axios.get("/process/ratio/" + this.query.examId).then((res) => {
          let data = res.data.data;
          if (data) {
            this.passRateList = data;
            this.visible = true;
          } else {
            this.passRateList = [];
            this.visible = false;
          }
        });
      }
    },
    // 全部下拉菜单
    getSelectList() {
      this.$axios.get("/process/newProvince").then((res) => {
        let data = res.data.data;
        this.proList = data;
      });
      this.$axios.get("/process/examinationSite").then((res) => {
        let data = res.data.data;
        this.examSitList = data;
      });
      this.$axios.get("/process/rationSite").then((res) => {
        let data = res.data.data;
        this.rationSiteList = data;
      });
    },
    operatInfo(type, row) {
      this.visibleType = type;
      if (type === 1) {
        //合格率
        this.getPassRate();
      } else if (type == 2) {
        //查看准考证
        window.open(
          `/api/process/look/${this.query.examId}/${row.userId}/${row.subjectLevel}`
        );
      } else if (type == 3) {
        // 个人视频
        this.visible = true;
        this.currentVideoList = row.videoList;
        this.currentVideoIndex = 1;
        let path = this.currentVideoList[this.currentVideoIndex - 1];
        this.setVideoSrc(path);
        this.$nextTick(() => {
          this.createBut();
        });
      }
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    getJudge() {
      this.$axios
        .get("judge/select")
        .then(({ data: res }) => {
          console.log(res);
          if (res.code === 10000) {
            this.judgeList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeModel(bool) {
      this.modelOption.modalVisiabal = bool;
      this.clearFrom();
    },
    allocationJug() {
      this.modelOption.modalVisiabal = true;
      this.modelOption.title = "分配评委";
    },
    selectCheck(row) {
      return !row.putAsh;
    },
    handleOk(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.multipleSelection.length !== 0) {
            this.$axios
              .post("process/set/judge", {
                ids: this.multipleSelection.map((item) => {
                  return item.id;
                }),
                judge: this.ruleForm.judge,
              })
              .then(({ data: res }) => {
                this.tableLoad();
                this.modelOption.modalVisiabal = false;
                this.clearFrom();
                this.$refs.elTable.clearSelection();
                this.multipleSelection = [];
                this.$message.success(res.msg);
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.$message.warning("至少选择一位学生进行分配！");
          }
        } else {
          return false;
        }
      });
    },
    calc() {
      this.modelOption.modalVisiabal = false;
      this.clearFrom();
    },
    clearFrom() {
      this.ruleForm = {
        judge: "",
      };
      this.$refs.ruleForm.resetFields();
    },
    //设置视频src
    setVideoSrc(path) {
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.player.src(path);
      }
      let videoType = path.substring(path.lastIndexOf(".") + 1);
      if (videoType === "mp4" || videoType === "MP4") {
        this.playerOptions.sources[0].type = "video/mp4";
      } else {
        this.playerOptions.sources[0].type = "application/x-mpegURL";
      }
      this.playerOptions.sources[0].src = path;
    },
    // 视频播完回调
    onPlayerEnded() {
      if (this.currentVideoIndex < this.currentVideoList.length) {
        this.currentVideoIndex++;
        let path = this.currentVideoList[this.currentVideoIndex - 1];
        this.setVideoSrc(path);
        setTimeout(() => {
          this.$refs.videoPlayer.player.play();
        }, 1000);
      }
    },
    //当前页改变事件
    handleCurrentChange(currentPage) {
      this.currentVideoIndex = currentPage;
      let path = this.currentVideoList[this.currentVideoIndex - 1];
      this.setVideoSrc(path);
    },
    submit() {
      if (this.passRateList.length == 0) {
        this.$message({
          type: "error",
          message: "数据为空,无法操作!",
          duration: 1000,
        });
        return;
      }
      this.$axios({
        method: "post",
        url: "/process/ratio",
        data: this.passRateList,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "保存成功!",
          duration: 1000,
        });
        this.visible = false;
        // this.getPassRate();
      });
    },
    proChange(val) {
      // this.query.examSiteId = "";
      // if (val == "") {
      //   this.examSitList = [];
      // } else {
      //   let proObj = this.proList.find((item) => {
      //     return item.provinceId === val;
      //   });
      //   this.examSitList = proObj.examSiteVOS;
      // }
      this.tableLoad();
    },
    importFile() {
      this.exportTicketLoading = true;
      this.$axios
        .post("/process/export", this.query, { responseType: "blob" })
        .then((res) => {
          exportFile(res);
          this.exportTicketLoading = false;
        });
    },
    setQualified() {
      this.$axios.get("/process/generate/" + this.query.examId).then((res) => {
        let { code, msg } = res.data;
        this.$message({
          type: code == 10000 ? "success" : "error",
          message: code == 10000 ? "已生成!" : msg,
          duration: 1000,
        });
        this.tableLoad();
      });
    },
    createBut() {
      let Button = videojs.getComponent("Button");
      let myButton = videojs.extend(Button, {
        constructor: function(player, options) {
          Button.apply(this, arguments);
          this.addClass("fullscreen-enter");
        },
        handleClick: () => {
          // 绑定点击事件
          this.videoRotate = this.videoRotate == 3 ? 0 : this.videoRotate + 1;
        },
        buildCSSClass: function() {
          return "iconfont pro-icon-xuanzhuan video-player-button";
        },
      });
      //注册
      videojs.registerComponent("myButton", myButton);
      // 添加到controlBar中
      this.$refs.videoPlayer.player.getChild("controlBar").addChild("myButton");
    },
    playerIsReady(player) {
      player.hotkeys({
        volumeStep: 0.1,
        seekStep: 5,
        enableModifiersForNumbers: false,
        fullscreenKey: function(event, player) {
          // override fullscreen to trigger when pressing the F key or Ctrl+Enter
          return event.which === 70 || (event.ctrlKey && event.which === 13);
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.wxts {
  color: #ff3e3e;
  padding: 5px 0px 10px;
}

.tableHearInputBox {
  .el-select {
    width: 200px;
    margin-right: 10px;
  }
}

::v-deep .el-table-column--selection .cell {
  text-align: center;
}
</style>
<style lang="scss">
.el-dialog__body {
  padding: 30px 20px 0 !important;
}

.examInfo {
  .tableNumInput {
    padding-left: 0px !important;
    padding-right: 0px !important;

    .el-input {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }

  .video-player-button {
    cursor: pointer;
    margin-right: 10px;
  }

  .video-player {
    padding: 0px 20px;
    width: calc(100% - 40px);

    .video-js {
      width: 100%;
      overflow: hidden;
      height: 700px;
    }
  }

  .videos-rotate1 {
    .vjs-tech {
      transform: rotateZ(-90deg);
    }
  }

  .videos-rotate2 {
    .vjs-tech {
      transform: rotateZ(-180deg);
    }
  }

  .videos-rotate3 {
    .vjs-tech {
      transform: rotateZ(-270deg);
    }
  }
}
</style>
